/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Stage = 0 | 1 | 2 | 3;

export const Stage = {
    NUMBER_0: 0 as Stage,
    NUMBER_1: 1 as Stage,
    NUMBER_2: 2 as Stage,
    NUMBER_3: 3 as Stage
};

